<template>
  <div>
      vaults
  </div>
</template>

<script>
export default {
    name:'StoreUserVault'
}
</script>

<style>

</style>